import CompaniesDataService from '../../service/CompaniesDataService';

const initialState = {
    companies: [],
    copyOfCompanies: [],
    companiesCount: 0,
    tableOptions: null,
    loading: false,
    stationLocationLongAliases: [],
    activeCompany: {},
};

export default {
    namespaced: true,
    state: {...initialState},
    getters: {
        getActiveCompanyStationLocationsUsers(state) {
            const uniqueUsers = [];
            if (!state.activeCompany) return [];
            const companyStationLocations = state.activeCompany.station_locations || [];
            companyStationLocations.forEach(stationLocation => {
                const stationLocationUsers = stationLocation.users || [];
                stationLocationUsers.forEach(user => {
                    if (!uniqueUsers.find(u => u.id === user.id)) {
                        uniqueUsers.push(user);
                    }
                });
            });

            return uniqueUsers;
        },
        getActiveCompany(state) {
            return state.activeCompany;
        },
    },
    actions: {
        async fetchStations({commit}, params) {
            commit('setLoading', true);
            if (!params.company_id) return alert('No active company set');
            try {
                const resp = await CompaniesDataService.getAllStations(params.company_id);
                if (resp.status === 200) {
                    return resp?.data.stations;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setLoading', false);
            }
            return null;
        },
        async AddStationToCompany({commit, dispatch}, params) {
            try {
                commit('setLoading', true);
                if (!params.active_company) return alert('No active company set');
                const resp = await CompaniesDataService.addStation(params.active_company.id, {station_id: params.station_id, user_ids: params.user_ids});
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Station added to company!',
                            type: 'success',
                        },
                        {root: true},
                    );
                    const newActiveCompany = {
                        ...params.active_company,
                        station_location_count: params.active_company.station_location_count + 1,
                        station_locations: [
                            ...params.active_company.station_locations,
                            resp?.data.new_station_location
                        ]
                    };
                    commit("setActiveCompany", newActiveCompany)
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Adding station to company failed!',
                            type: 'error',
                        },
                        {root: true},
                    );
                }
            } catch (e) {
                console.log(e);
            }
            finally {
                commit('setLoading', false);
            }
        },
        async fetchCompanies({commit, state}) {
            try {
                let params = {
                    page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : null,
                    itemsPerPage:
                        state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : null,
                };
                commit('setLoading', true);

                let resp = await CompaniesDataService.getAll(params);

                if (resp.status === 200) {
                    commit('setCompanies', resp?.data?.companies);
                    commit('setCompaniesCount', resp?.data?.companies_count);
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },
        async fetchCompany({commit}, companyId) {
            try {
                commit('setLoading', true);

                let resp = await CompaniesDataService.get(companyId, {});

                if (resp.status === 200) {
                    commit('setActiveCompany', resp?.data?.company);
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },
        async fetchStationLocationLongAliases({commit}) {
            try {
                let params = {};
                commit('setLoading', true);

                let resp = await CompaniesDataService.getAllStationLocationLongAliases(params);

                if (resp.status === 200) {
                    commit('setStationLocationLongAliases', resp?.data);
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },
        async fetchCompanyStationLocations({commit}, companyId) {
            try {
                return await CompaniesDataService.getStationLocations(companyId);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }

            return null;
        },

        async toggleCompanyHasPredictionRights({commit, dispatch}, {itemId, value}) {
            try {
                commit('setLoading', true);
                const data = {value};
                const resp = await CompaniesDataService.updateCompanyHasPredictionRights(itemId, data);
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Has prediction rights data updated!',
                            type: 'success',
                        },
                        {root: true},
                    );
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Update failed (has prediction rights)!',
                            type: 'error',
                        },
                        {root: true},
                    );
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },

        async editCompanyField({commit, dispatch}, {itemId, field, value}) {
            try {
                commit('setLoading', true);
                const data = {value, field};
                const resp = await CompaniesDataService.editCompanyField(itemId, data);
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Client number updated!',
                            type: 'success',
                        },
                        {root: true},
                    );
                    await dispatch('fetchCompanies');
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Update failed (client number)!',
                            type: 'error',
                        },
                        {root: true},
                    );
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },

        async createCompany({commit, dispatch}, companyData) {
            try {
                commit('setLoading', true);
                const itemId = companyData.id || null;
                const resp = await CompaniesDataService.createCompany(itemId, companyData);
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Company added!',
                            type: 'success',
                        },
                        {root: true},
                    );
                    await dispatch('fetchCompanies');
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Creating failed',
                            type: 'error',
                        },
                        {root: true},
                    );
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },
        async updateCompany({commit, dispatch}, companyData) {
            try {
                commit('setLoading', true);
                const itemId = companyData.id || null;
                const resp = await CompaniesDataService.editCompany(itemId, companyData);
                if (resp.status === 200) {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Company saved!',
                            type: 'success',
                        },
                        {root: true},
                    );
                } else {
                    await dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Creating failed',
                            type: 'error',
                        },
                        {root: true},
                    );
                }
                commit('setLoading', false);
            } catch (e) {
                console.log(e);
                commit('setLoading', false);
            }
        },
    },
    mutations: {
        setCompanies(state, data) {
            state.companies = data;
            state.copyOfCompanies = data.map(a => {
                return {...a};
            });
        },

        setCompaniesCount(state, count) {
            state.companiesCount = count;
        },

        setStationLocationLongAliases(state, data) {
            state.stationLocationLongAliases = data;
        },

        setActiveCompany(state, data) {
            state.activeCompany = data;
        },

        setTableOptions(state, data) {
            state.tableOptions = data;
            this.dispatch('company/fetchCompanies');
        },
        setLoading(state, bool) {
            state.loading = bool;
        },
    },
};